function formatTimezone(momentDate) {
  const timezoneIdentifier = momentDate.format('z');
  const timezoneOffsetInMinutes = momentDate.utcOffset();
  const prefix = timezoneOffsetInMinutes >= 0 ? '+' : '';
  const hours = Math.floor(timezoneOffsetInMinutes / 60);
  const minutes = timezoneOffsetInMinutes % 60;
  const minutesString = minutes !== 0 ? ':' + minutes : '';
  return `${timezoneIdentifier}${prefix}${hours}${minutesString}`;
}

export default formatTimezone;